import { createAction } from '@reduxjs/toolkit';

export const globalReset = createAction<void>('reset');
